/* import __COLOCATED_TEMPLATE__ from './buyer-feedback-general.hbs'; */
import Component from '@ember/component';
import HappyIcon from 'sh-www/components/sentiment-happy';
import NeutralIcon from 'sh-www/components/sentiment-neutral';
import UnhappyIcon from 'sh-www/components/sentiment-unhappy';

const icons = [
  { sentiment: 'unhappy', icon: UnhappyIcon },
  { sentiment: 'neutral', icon: NeutralIcon },
  { sentiment: 'happy', icon: HappyIcon },
];

export default Component.extend({
  /** @inheritDoc */
  tagName: 'aside',

  /** @inheritDoc */
  classNames: ['buyer-feedback'],

  /** @inheritDoc */
  classNameBindings: ['hidden:buyer-feedback--hidden'],

  /** @type {boolean} */
  hidden: true,

  get sentimentIcons() {
    return icons;
  },

  /** @type {number} */
  handler: 0,

  /** @param {function} */
  onAskLater: undefined,

  /** @param {function} */
  onSentimentClick: undefined,

  /** @inheritDoc */
  didInsertElement() {
    this._super(...arguments);

    this.set('handler', setTimeout(() => {
      this.setProperties({ handler: 0, hidden: false });
    }, 1000));
  },

  /** @inheritDoc */
  willDestroyElement() {
    this._super(...arguments);

    const timeout = this.get('handler');

    if (timeout) {
      clearTimeout(timeout);
    }
  },

  /** @inheritDoc */
  actions: {

    /**
     *
     */
    onAskLater() {
      this.onAskLater();
    },

    /**
     *
     * @param {string} overallSentiment
     */
    onSentimentClick(overallSentiment) {
      this.onSentimentClick(overallSentiment);
    },
  },
});
